import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { toBase64 } from '../bridges/frontend-data-bridge.js'

@Pipe({
	name: 'arrayBufferSrc',
	standalone: false,
})
export class ArrayBufferSrcPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(arrayBuffer: ArrayBuffer, mimeType: string): SafeResourceUrl {
		if (arrayBuffer == null) return null
		if (!(arrayBuffer instanceof ArrayBuffer)) {
			console.error(
				'arrayBufferSrc: arrayBuffer is not an ArrayBuffer',
				arrayBuffer,
			)
			return null
		}

		const base64 = toBase64(arrayBuffer)
		const url = `data:${mimeType};base64,${base64}`
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}
}
